import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { ReportExpandedViewTypesEnum } from '../report-data.data';
import { ExpandedViewItem } from './sub-models/expanded-view-item.model';
import { ExpandedViewCta } from './sub-models/expanded-view-cta.model';
import { BarGraph } from './sub-models/bar-graph.model';

export const EXPANDED_SUMMARY_SCHEMA = Object.freeze({
  TITLE: '',
  SUBTITLE: '',
  QUANTITY: 0,
  ADDITIONAL_NOTE: '',
  CURRENCY_CODE: '',
  TOTAL_AMOUNT: 0,
  TYPE: ReportExpandedViewTypesEnum,
  ITEMS: List<ExpandedViewItem>([]),
  ALL_OTHER_SUMMARY: ExpandedViewItem,
  BAR_GRAPH: BarGraph,
  CTA: ExpandedViewCta,
});
export const RECORD = generateSchema(EXPANDED_SUMMARY_SCHEMA);
export const KEYS: any = generateKeys(EXPANDED_SUMMARY_SCHEMA);

export class ExpandedSummary extends Record(RECORD) {
  static KEYS: any = KEYS;

  static fromJsonList(array: any[]): List<ExpandedSummary> {
    return List<ExpandedSummary>(
      array ? array.map((props) => new ExpandedSummary(props)) : []
    );
  }

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.ITEMS,
        value: props.get(KEYS.ITEMS)
          ? ExpandedViewItem.fromJsonList(props.get(KEYS.ITEMS))
          : List<ExpandedViewItem>([]),
      },
      {
        key: KEYS.ALL_OTHER_SUMMARY,
        value: props.get(KEYS.ALL_OTHER_SUMMARY)
          ? new ExpandedViewItem(props.get(KEYS.ALL_OTHER_SUMMARY))
          : null,
      },
      {
        key: KEYS.CTA,
        value: new ExpandedViewCta(props.get(KEYS.CTA)),
      },
      {
        key: KEYS.BAR_GRAPH,
        value: props.get(KEYS.BAR_GRAPH)
          ? new BarGraph(props.get(KEYS.BAR_GRAPH))
          : null,
      },
    ]);

    return selfModel as ExpandedSummary;
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get subtitle(): string {
    return this.get(KEYS.SUBTITLE);
  }

  get quantity(): number {
    return this.get(KEYS.QUANTITY);
  }

  get additionalNote(): string {
    return this.get(KEYS.ADDITIONAL_NOTE);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get totalAmount(): number {
    return this.get(KEYS.TOTAL_AMOUNT);
  }

  get type(): ReportExpandedViewTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get items(): List<ExpandedViewItem> {
    return this.get(KEYS.ITEMS);
  }

  get allOtherSummary(): ExpandedViewItem {
    return this.get(KEYS.ALL_OTHER_SUMMARY);
  }

  get cta(): ExpandedViewCta {
    return this.get(KEYS.CTA);
  }

  get barGraph(): BarGraph {
    return this.get(KEYS.BAR_GRAPH);
  }
}
